/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:message
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/21 | 富士通株式会社        | 新規作成
//================================================================================
 */
// メッセージ一覧
export const message = {
	namespaced: true,
	state: {
		msgMap: {}
	},
	getters: {
		// メッセージを取得
		getMessage(state) { return function (id) {
				if ( state.msgMap[id] ) {
					return state.msgMap[id];
				}
				return id;
			}
		}
	},
	mutations: {
		// メッセージ情報を設定
		setMessageInfo(state, msgMap) {
			state.msgMap = msgMap;
		}
	},
	actions: {
	},
	modules: {
	}
}